import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { DEFAULT_STEPPER_CONFIG, StepConfig, StepperButton, StepperConfig } from './stepper.model';

@Component({
  standalone: false,
  selector: 'app-stepper-container',
  templateUrl: './stepper-container.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./stepper-container.component.scss'],
})
export class StepperContainerComponent {
  @Input() config: StepperConfig = { ...DEFAULT_STEPPER_CONFIG };
  @Output() stepChanged = new EventEmitter<StepConfig>();

  activeStepIndex = 0;

  get steps() {
    return this.config?.steps.filter(step => step?.visible?.() ?? true) || [];
  }

  private updateStep(index: number) {
    this.activeStepIndex = index;
    this.stepChanged.emit(this.steps[this.activeStepIndex]);
  }

  goToStep(index: number) {
    if (this.config.linear && index > this.activeStepIndex + 1) return;

    const currentStep = this.steps[this.activeStepIndex];
    if (currentStep?.canProceed?.() === false) return;

    this.updateStep(index);
  }

  async handleNext(): Promise<void> {
    const currentStep = this.steps[this.activeStepIndex];
    if (currentStep?.onNext) {
      const canProceed = await Promise.resolve(currentStep.onNext());
      if (!canProceed) return;
    }
    this.next();
  }

  next() {
    const currentStep = this.steps[this.activeStepIndex];
    if (currentStep?.canProceed?.() === false) return;

    if (this.activeStepIndex < this.steps.length - 1) {
      this.updateStep(this.activeStepIndex + 1);
    }
  }

  back() {
    if (this.activeStepIndex > 0) {
      this.updateStep(this.activeStepIndex - 1);
    }
  }

  isButtonDisabled(btn: StepperButton): boolean {
    return (btn.disabled?.() ?? false) || (btn.loading?.() ?? false);
  }

  getButtonLabel(btn: StepperButton): string {
    return btn.loading?.() && btn.loadingLabel ? btn.loadingLabel : btn.label;
  }
}
